import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { Badge } from '../../components/ui/Badge';
import { PlusIcon, SearchIcon, FilterIcon, ArrowLeftIcon, ShieldAlertIcon } from 'lucide-react';
import { suppliers } from '../../data/suppliers';
export const Supplier360Page: React.FC = () => {
  const [selectedSupplier, setSelectedSupplier] = useState<any>(null);
  const [activeTab, setActiveTab] = useState('overview');
  if (selectedSupplier) {
    return <div className="max-w-7xl mx-auto space-y-6" data-id="element-645">
        <Button variant="ghost" leftIcon={<ArrowLeftIcon className="w-4 h-4" data-id="element-647" />} onClick={() => setSelectedSupplier(null)} className="mb-2 -ml-4" data-id="element-646">
          Back to Suppliers
        </Button>
        <div className="flex justify-between items-start" data-id="element-648">
          <div data-id="element-649">
            <div className="flex items-center gap-3 mb-1" data-id="element-650">
              <h1 className="text-2xl font-bold text-text-primary" data-id="element-651">
                {selectedSupplier.name}
              </h1>
              <StatusPill status={selectedSupplier.status} data-id="element-652" />
              <Badge variant="info" data-id="element-653">{selectedSupplier.supplierType}</Badge>
            </div>
            <p className="text-text-secondary" data-id="element-654">
              ID: {selectedSupplier.id} • {selectedSupplier.country} •{' '}
              {selectedSupplier.category}
            </p>
          </div>
          <div className="flex gap-2" data-id="element-655">
            <Button variant="secondary" data-id="element-656">Request Info</Button>
            <Button variant="primary" data-id="element-657">Edit Profile</Button>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-658">
          <Card className="p-4 flex flex-col justify-center items-center text-center" data-id="element-659">
            <p className="text-sm text-text-secondary mb-1" data-id="element-660">Risk Score</p>
            <div className={`text-3xl font-bold ${selectedSupplier.riskLevel === 'low' ? 'text-status-success' : selectedSupplier.riskLevel === 'medium' ? 'text-status-warning' : 'text-status-error'}`} data-id="element-661">
              {selectedSupplier.riskScore}/100
            </div>
            <p className="text-xs text-text-tertiary mt-1 capitalize" data-id="element-662">
              {selectedSupplier.riskLevel} Risk
            </p>
          </Card>
          <Card className="p-4 flex flex-col justify-center" data-id="element-663">
            <p className="text-sm text-text-secondary mb-1" data-id="element-664">Annual Spend</p>
            <p className="text-2xl font-bold text-text-primary" data-id="element-665">
              ${(selectedSupplier.annualSpend / 1000000).toFixed(1)}M
            </p>
          </Card>
          <Card className="p-4 flex flex-col justify-center" data-id="element-666">
            <p className="text-sm text-text-secondary mb-1" data-id="element-667">Open POs</p>
            <p className="text-2xl font-bold text-text-primary" data-id="element-668">
              {selectedSupplier.openPOs}
            </p>
          </Card>
          <Card className="p-4 flex flex-col justify-center" data-id="element-669">
            <p className="text-sm text-text-secondary mb-1" data-id="element-670">Service Level</p>
            <p className="text-2xl font-bold text-text-primary" data-id="element-671">
              {selectedSupplier.serviceLevel}%
            </p>
          </Card>
        </div>

        <Card noPadding data-id="element-672">
          <div className="px-6 pt-4 border-b border-border-light" data-id="element-673">
            <Tabs tabs={[{
            id: 'overview',
            label: 'Overview'
          }, {
            id: 'qualification',
            label: 'Qualification'
          }, {
            id: 'contracts',
            label: 'Contracts'
          }, {
            id: 'transactions',
            label: 'Orders & Invoices'
          }, {
            id: 'risk',
            label: 'Risk & Compliance'
          }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-674" />
          </div>
          <div className="p-6" data-id="element-675">
            {activeTab === 'overview' && <div className="grid grid-cols-2 gap-8" data-id="element-676">
                <div data-id="element-677">
                  <h3 className="text-lg font-semibold mb-4" data-id="element-678">
                    Company Details
                  </h3>
                  <div className="space-y-3" data-id="element-679">
                    <div className="grid grid-cols-3" data-id="element-680">
                      <span className="text-text-secondary" data-id="element-681">Legal Name</span>
                      <span className="col-span-2 font-medium" data-id="element-682">
                        {selectedSupplier.legalName}
                      </span>
                    </div>
                    <div className="grid grid-cols-3" data-id="element-683">
                      <span className="text-text-secondary" data-id="element-684">Tax ID</span>
                      <span className="col-span-2 font-medium" data-id="element-685">
                        {selectedSupplier.taxId}
                      </span>
                    </div>
                    <div className="grid grid-cols-3" data-id="element-686">
                      <span className="text-text-secondary" data-id="element-687">
                        Category Owner
                      </span>
                      <span className="col-span-2 font-medium" data-id="element-688">
                        {selectedSupplier.categoryOwner}
                      </span>
                    </div>
                    <div className="grid grid-cols-3" data-id="element-689">
                      <span className="text-text-secondary" data-id="element-690">
                        Primary Contact
                      </span>
                      <span className="col-span-2 font-medium" data-id="element-691">
                        {selectedSupplier.primaryContact} (
                        {selectedSupplier.primaryContactEmail})
                      </span>
                    </div>
                  </div>
                </div>
                <div data-id="element-692">
                  <h3 className="text-lg font-semibold mb-4" data-id="element-693">
                    Recent Activity
                  </h3>
                  <div className="space-y-4" data-id="element-694">
                    <div className="flex gap-3" data-id="element-695">
                      <div className="w-2 h-2 mt-1.5 rounded-full bg-fpg-navy" data-id="element-696"></div>
                      <div data-id="element-697">
                        <p className="text-sm font-medium" data-id="element-698">
                          Invoice INV-2026-00089 Approved
                        </p>
                        <p className="text-xs text-text-tertiary" data-id="element-699">
                          Mar 12, 2026
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-3" data-id="element-700">
                      <div className="w-2 h-2 mt-1.5 rounded-full bg-fpg-navy" data-id="element-701"></div>
                      <div data-id="element-702">
                        <p className="text-sm font-medium" data-id="element-703">
                          Contract CTR-2024-001 Updated
                        </p>
                        <p className="text-xs text-text-tertiary" data-id="element-704">
                          Dec 15, 2025
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {activeTab !== 'overview' && <div className="py-8 text-center text-text-secondary" data-id="element-705">
                <p data-id="element-706">
                  Detailed view for {activeTab} is available in the full system.
                </p>
              </div>}
          </div>
        </Card>
      </div>;
  }
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-707">
      <PageHeader title="Supplier 360" description="Unified view of supplier profiles, performance, and risk." primaryAction={<Button leftIcon={<PlusIcon className="w-4 h-4" data-id="element-710" />} data-id="element-709">
            Add Supplier
          </Button>} data-id="element-708" />

      <Card noPadding data-id="element-711">
        <div className="p-4 border-b border-border-light flex gap-4 bg-surface-secondary" data-id="element-712">
          <div className="relative flex-1" data-id="element-713">
            <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-text-tertiary" data-id="element-714" />
            <input type="text" placeholder="Search suppliers by name, ID, or tax number..." className="w-full pl-9 pr-4 py-2 text-sm border border-border-default rounded-fluent focus:outline-none focus:ring-2 focus:ring-fpg-navy" data-id="element-715" />
          </div>
          <Button variant="secondary" leftIcon={<FilterIcon className="w-4 h-4" data-id="element-717" />} data-id="element-716">
            Filters
          </Button>
        </div>
        <DataTable data={suppliers} columns={[{
        header: 'Supplier Name',
        accessorKey: 'name',
        cell: row => <span className="font-medium text-fpg-navy" data-id="element-719">{row.name}</span>
      }, {
        header: 'ID',
        accessorKey: 'id'
      }, {
        header: 'Category',
        accessorKey: 'category'
      }, {
        header: 'Country',
        accessorKey: 'country'
      }, {
        header: 'Risk',
        cell: row => <div className="flex items-center gap-1" data-id="element-720">
                  <div className={`w-2 h-2 rounded-full ${row.riskLevel === 'low' ? 'bg-status-success' : row.riskLevel === 'medium' ? 'bg-status-warning' : 'bg-status-error'}`} data-id="element-721"></div>
                  <span className="text-sm capitalize" data-id="element-722">{row.riskLevel}</span>
                </div>
      }, {
        header: 'Status',
        cell: row => <StatusPill status={row.status} data-id="element-723" />
      }]} onRowClick={setSelectedSupplier} data-id="element-718" />
      </Card>
    </div>;
};